export const GAME_DETAIL_MODULE_KEY_MAPPING = {
  GAME_INFORMATION: 'game_information',
  VISUAL_SHOWCASE: 'visual_showcase',
  SIMILAR_GAMES: 'similar_games',
};

export const GAME_PILLAR_IMG_LIST = [
  {
    id: 0,
    cloud_path: '',
    title: '',
    introduction: '',
    cover: '',
    operation_user: '',
    sort: '1',
    status: true,
    loading: false,
  },
  {
    id: 0,
    cloud_path: '',
    title: '',
    introduction: '',
    cover: '',
    operation_user: '',
    sort: '2',
    status: true,
    loading: false,
  },
  {
    id: 0,
    cloud_path: '',
    title: '',
    introduction: '',
    cover: '',
    operation_user: '',
    sort: '3',
    status: true,
    loading: false,
  },
  {
    id: 0,
    cloud_path: '',
    title: '',
    introduction: '',
    cover: '',
    operation_user: '',
    sort: '4',
    status: true,
    loading: false,
  },
  {
    id: 0,
    cloud_path: '',
    title: '',
    introduction: '',
    cover: '',
    operation_user: '',
    sort: '5',
    status: true,
    loading: false,
  },
];

export const ELEVATOR_PITCH_IMG_DATA = {
  cloud_path: '',
  introduction: '',
};
